import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { updateLead } from '../api/leads';

/**
 * Change lead status (used by DnD and status picker).
 */
export function useChangeLeadStatus () {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({ leadId, statusId }) => updateLead(leadId, { status: statusId }),

    onMutate: async ({ leadId, statusId, previousStatusId }) => {
      await qc.cancelQueries({ queryKey: ['leads', 'column'] });

      const columnQueries = qc.getQueriesData({ queryKey: ['leads', 'column'] });

      return { columnQueries, previousStatusId };
    },

    onError: (_err, _vars, context) => {
      if (context?.columnQueries) {
        for (const [key, data] of context.columnQueries) {
          if (data) qc.setQueryData(key, data);
        }
      }
    },

    onSettled: () => {
      qc.invalidateQueries({ queryKey: ['leads', 'column'] });
      qc.invalidateQueries({ queryKey: queryKeys.leads.boardStats() });
    },
  });
}
